import Swal from "sweetalert2";
import { GetKey } from "../../../Helpers/GetKey";
// import { GetKey } from "../../../Helpers/GetKey";

const titulo = "Clientes";
const error = "error";
export const ValidaContacto = (state) => {
  if (state === undefined || state === null) {
    Swal.fire(
      "Clientes",
      "Error interno, favor de comunicarse con el administrador del sistema",
      "error"
    );
    return false;
  }

  if (
    state.mediocontacto === undefined ||
    state.mediocontacto === null ||
    state.mediocontacto === ""
  ) {
    Swal.fire(titulo, "El campo medio de contacto es obligatorio", error);
    return false;
  }
  if (
    state.tipocontacto === undefined ||
    state.tipocontacto === null ||
    state.tipocontacto === ""
  ) {
    Swal.fire(titulo, "El campo tipo de contacto es obligatorio", error);
    return false;
  }
  if (state.valor === undefined || state.valor === null || state.valor === "") {
    Swal.fire(titulo, "El campo valor es obligatorio", error);
    return false;
  }

  return {
    idcliente: "",
    orden: "",
    // idlocalidad: Number(GetKey(state.localidad)),
    medio_contacto: GetKey(state.mediocontacto),
    tipo_contacto: GetKey(state.tipocontacto),
    valor: state.valor,
    comentarios: state.comentarios,
    estatus: true,
  };
};
